<template>
  <div>
    <div class="md-layout md-gutter" v-if="term">
      <div class="md-layout-item">
        <h1 class="md-headline text-right">{{ term.name[0].value }}</h1>
        <md-content v-if="term.description.length">
          <div v-html="term.description[0].value"></div>
          <div v-if="term.field_geolocation.length">
            <h2 class="md-subheader">{{ translations[$store.state.lang].term.getThere }}</h2>
            <iframe :src="'https://maps.google.com/maps?q=' + term.field_geolocation[0].lat + ',' + term.field_geolocation[0].lng + '&hl=ca&z=16&amp;output=embed'" width="100%" height="400" frameborder="0" style="border:0" allowfullscreen></iframe>
          </div>
          <md-list v-if="pages">
            <md-list-item v-for="page in pages" :key="page.nid[0].value" :to="{name: 'node', params: {lang: $store.state.lang, nid: page.nid[0].value }}">
              <md-avatar v-if="page.field_images.length">
                <img :src="page.field_images[0].url|imageStyle" alt="">
              </md-avatar>
              <div class="md-list-item-text">{{ page.title[0].value }}</div>
            </md-list-item>
          </md-list>
        </md-content>
      </div>
    </div>
  </div>
</template>

<script>

    import {API} from "@/variables";
    import {LANG} from "@/lang";

    export default {
        name: "vue-term",
        metaInfo() {
            return {
                title: this.term ? this.term.name[0].value : ''
            }
        },
        data() {
            return {
                translations: LANG,
                term: null,
                pages: null,
            }
        },
        created() {

            this.tid = this.$route.params.tid;
            this.lang = this.$route.params.lang;
            this.$store.commit('language', this.$route.params.lang);

            this.getPlace(this.lang, this.tid);

        },
        methods: {
            getPlace(lang, tid) {
                this.$http.get(API.protocol + API.ip + '/' + this.lang + '/taxonomy/term/' + tid + '?_format=json', {
                    header: {
                        'Content-Type': 'application/hal+json',
                    },
                    //withCredentials: true
                })
                    .then((resp) => {
                        this.term = resp.data;
                        this.getPages(lang, tid);
                    })
            },
            getPages(lang, tid) {
                this.$http.get(API.protocol + API.ip + '/' + this.lang + '/api/' + tid + '/pages', {
                    header: {
                        'Content-Type': 'application/hal+json',
                    },
                })
                    .then((resp) => {
                        this.pages = resp.data;
                    })
            }
        },
        filters: {
            imageStyle(value) {
                return value.replace('/sites/default/files/', '/sites/default/files/styles/mobile/public/') + '.jpg';
            }
        }
    }
</script>

<style scoped>

</style>
